export const GET_POSTS = 'GET_POSTS';
export const SEARCH_POSTS = 'SEARCH_POSTS';
export const SET_LOADING = 'SET_LOADING';
export const SET_READMORE_LOADING = 'SET_READMORE_LOADING';
export const LOAD_MORE_POSTS = 'LOAD_MORE_POSTS';
export const GET_FILTRED_POSTS = 'GET_FILTRED_POSTS';
export const SET_ORDER = 'SET_ORDER';



// WEBPACK FOOTER //
// ./src/context/types.js